module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av246-fd9e8c38d151acc93d43886499c5749a.jpg";